<div [class.d-none]="carregandoState | async" class="app-container" style="font-family: 'Nunito', sans-serif;">
  <!-- Header fixo no topo -->
  <ng-container *ngIf="(showMainLayout$ | async) && (isPrintRoute$ | async) === false">
    <mat-toolbar
      *ngIf="(exibirLayouState | async) === true"
      color="primary"
      class="header"
    >
      <div class="start-section">
        <button
          *ngIf="(hideSidenav | async) === false"
          (click)="sidenavToggle()"
          mat-icon-button
          class="menu-toggle-btn"
        >
          <mat-icon
            class="menu-icon"
            [svgIcon]="(sidenavExpanse | async) ? 'left_panel_close' : 'left_panel_open'">
          </mat-icon>
        </button>
        <div class="header-img">
          <ng-container *ngIf="logoState | async; else defaultLogo">
            <img class="logo" [src]="(logoState | async)" alt="logo" (click)="irParaUrl('/')" (keydown)="irParaUrl('/')" tabindex="0" style="cursor: pointer;"/>
          </ng-container>
          <ng-template #defaultLogo>
            <img
              class="logo"
              src="assets/images/MDSLogo_blue_Mobiis.svg"
              alt="Mobiis"
              (click)="isAdminUser ? openSettingsMenu() : irParaUrl('/')"
              (keydown)="isAdminUser ? openSettingsMenu() : irParaUrl('/')"
              tabindex="0"
              style="cursor: pointer;"
            />
          </ng-template>
          <img
            src="assets/images/header_product.svg"
            alt="Torre de controle"
            class="header-product-label"
          />
          <!-- <span class="ml-3 mt-2 text-gray-600" style="font-size: 18px; font-weight: 400;"
            >Olá, {{ (authState | async)?.nickname }}</span
          > -->
        </div>
      </div>

      <div class="center-section"></div>

      <div class="end-section">
        <div class="filter-date-group">
          <div>
            <div class="input-container">
              <div>
                <div
                  (click)="picker.open()"
                  (keydown.enter)="picker.open()"
                  (keydown.space)="picker.open()"
                  [formGroup]="formDate"
                  class="data-container"
                  [class.change]="!isNow()"
                >
                  <span>{{ relogioTempoState | async | date : format }}</span>
                  <mat-form-field style="visibility: hidden; width: 0">
                    <input
                      [matDatepicker]="picker"
                      [matDatepickerFilter]="filterData"
                      [min]="minDate"
                      [max]="maxDate"
                      formControlName="date"
                      matInput
                    />
                    <mat-datepicker #picker [dateClass]="dateClass">
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <!-- Ícone para quando está com data/hora atual (tempo real) -->
              <mat-icon
                *ngIf="isNow()"
                class="icon-calendar"
                svgIcon="calendar"
                tabindex="0"
                (click)="picker.open()"
                (keydown.enter)="picker.open()"
                (keydown.space)="picker.open()">
              </mat-icon>
              <!-- Ícone para quando uma data específica foi selecionada -->
              <mat-icon
                *ngIf="!isNow()"
                class="icon-selected-calendar"
                svgIcon="calendar2"
                matTooltip="Voltar para hoje"
                tabindex="0"
                (click)="hoje()"
                (keydown.enter)="hoje()"
                (keydown.space)="hoje()">
              </mat-icon>
            </div>
          </div>

          <ng-container *ngIf="(state$ | async)?.loaded && (state$ | async)?.filtrosCarregados; else skeletonFiltro">
            <app-toolbar-filtro
              *ngIf="checkRoles(GRID_PATH, roles | async)"
              [filtros]="filtros"
              [state$]="state$"
              [searchFormGroup]="searchFormGroup"
            ></app-toolbar-filtro>
          </ng-container>
          <ng-template #skeletonFiltro>
            <ngx-skeleton-loader
              [theme]="{ 'height.px': 45, 'width.px': 400, 'marginTop.px': 15 }"
              count="1"
            >
            </ngx-skeleton-loader>
          </ng-template>
        </div>

        <div class="header-separator"></div>

        <div class="header-icons">
          <!-- Botão de configurações: escondido para admins pois eles só tem acesso ao settings menu -->
          <button
            type="button"
            class="header-icon-clickable"
            *ngIf="checkRoles(CONFIG_PATH, roles | async) && !isAdminUser"
            (click)="openSettingsMenu()"
            [class.active]="(activeMenu | async) === 'settings'"
            matTooltip="Configurações">
            <mat-icon class="header-icon" svgIcon="configs"></mat-icon>
          </button>
          <a
            href="https://mobiis.desk.ms"
            target="_blank"
            rel="noopener noreferrer"
            class="header-icon-wrapper"
            matTooltip="Suporte">
            <mat-icon class="header-icon" svgIcon="duvidas"></mat-icon>
          </a>
        </div>

        <div class="perfil-container">
          <a
            (menuClosed)="menuToggle(false)"
            (menuOpened)="menuToggle(true)"
            [matMenuTriggerFor]="opcoes"
            class="options-button"
          >
            <img
              #profile
              (error)="imgDefault(profile)"
              [src]="profileUrlState | async"
              alt="profile"
            />

            <ng-container
              *ngIf="(menuExpandidoState | async) === false; else MenuOpcoes"
            >
              <mat-icon class="icone-animation text-black">arrow_drop_down</mat-icon>
            </ng-container>
            <ng-template #MenuOpcoes>
              <mat-icon class="icone-animation text-black">arrow_drop_up</mat-icon>
            </ng-template>
          </a>
        </div>
      </div>
    </mat-toolbar>
  </ng-container>

  <!-- Outlet para impressão (fora do layout principal) -->
  <router-outlet name="print"></router-outlet>

  <!-- Container principal com menu lateral + conteúdo -->
  <ng-container *ngIf="(isPrintRoute$ | async) === false">
  <mat-sidenav-container class="main" hasBackdrop="false">
    <mat-sidenav
      #Sidenav
      class="mat-sidenav"
      [disableClose]="true"
      [opened]="(hideSidenav | async) === false"
      [mode]="'side'"
      [ngClass]="
        (sidenavExpanse | async) ? 'sidenav-aberto' : 'sidenav-fechado'
      "
      *ngIf="showMainLayout$ | async"
    >
      <app-menu
        *ngIf="(activeMenu | async) === 'main'"
        [menuOpened]="menuOpened"
        [sidenavExpanse]="sidenavExpanse"
        [roles]="roles"
        [alertesPadding]="alertesPadding"
      ></app-menu>

      <app-settings-menu
        *ngIf="(activeMenu | async) === 'settings'"
        [menuOpened]="menuOpened"
        [sidenavExpanse]="sidenavExpanse"
        [roles]="roles"
        [alertesPadding]="alertesPadding"
        (voltarParaMenuPrincipal)="openMainMenu()"
      ></app-settings-menu>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  </ng-container>
</div>

<ng-container *ngIf="carregandoState | async">
  <div class="animacao-container">
    <mat-spinner [strokeWidth]="3"></mat-spinner>
  </div>
</ng-container>

<mat-menu #opcoes="matMenu">
  <div class="user-profile-header" style="font-family: 'Nunito', sans-serif;">
    <img
      #profile
      (error)="imgDefault(profile)"
      [src]="profileUrlState | async"
      alt="profile"
    />
    <span class="user-nickname" style="font-family: 'Nunito', sans-serif;">
      {{ (authState | async)?.nickname }}
    </span>
  </div>

  <div mat-menu-item disabled class="info-user" style="font-family: 'Nunito', sans-serif;">
    <div class="user-info-content">
      <span class="nome-empresa" *ngIf="(authState | async)?.nomeEmpresa" style="font-family: 'Nunito', sans-serif;">
        {{ (authState | async)?.nomeEmpresa }}
      </span>
      <span class="empresa" style="font-family: 'Nunito', sans-serif;">
        {{ (authState | async)?.empresa }}
      </span>
    </div>
  </div>

  <br>
  <!-- <mat-divider></mat-divider> -->

  <!-- <button
    mat-menu-item
    type="button"
    class="menu-config-item"
    *ngIf="checkRoles(CONFIG_PATH, roles | async)"
    (click)="irParaUrl('/configuracoes')"
    matTooltip="Configurações">
    <mat-icon class="header-icon" svgIcon="configs"></mat-icon>
    Configurações
  </button> -->

  <!-- <mat-divider></mat-divider>

  <button mat-menu-item class="menu-support-item" style="font-family: 'Nunito', sans-serif;">
    <mat-icon>help_outline</mat-icon>
    Suporte ao Cliente
  </button> -->

  <mat-divider></mat-divider>

  <button mat-menu-item (click)="logout(true)" class="logout-menu-item" style="font-family: 'Nunito', sans-serif;">
    <mat-icon>logout</mat-icon>
    Sair
  </button>
</mat-menu>

<!-- Componente de notificação -->
<app-notification></app-notification>
